/* eslint-disable */
import React, { useContext, useMemo } from 'react';
import { UserContext } from '../../../App';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../../form/legal-pack/legal-pack.module.css'; // même CSS que le funnel création
import { isImmoNaf, premiumPriceFor, tierPrices } from '../../../utils/gestion-pricing';
import dataLayerPush from '../../../utils/data-layer';

function GestionPacks() {
    const { company, handleChange } = useContext(UserContext);
    const navigate = useNavigate();

    const companyName = company.form.pappers?.denomination || company.form.dealname || 'votre entreprise';

    // Valeurs saisies dans gestion/accounting
    const codeNaf = company.form.pappers?.code_naf || '';
    const ca      = parseInt(company.form.chiffre_affaires) || 0;
    const nbBiens = parseInt(company.form.nb_biens) || 1;
    const isImmo  = isImmoNaf(codeNaf);

    const premium = useMemo(
        () => premiumPriceFor({ ca, codeNaf, nbBiens }),
        [ca, codeNaf, nbBiens]
    );
    const { premium: premiumPrice, standard: standardPrice, debutant: debutantPrice } = useMemo(
        () => tierPrices(premium),
        [premium]
    );

    function handleSubmit(event) {
        event.preventDefault();
        const button_choice = event.target.closest(`.big-button, .cta, .later, .next, .${styles['offer-box']}`);
        if (button_choice) {
            const choice   = button_choice.getAttribute('choice');
            const parent   = button_choice.parentElement;
            const question = parent.getAttribute('question');

            const selectedPrice =
                choice === 'Premium & Réussite' ? premiumPrice :
                choice === 'Standard'           ? standardPrice :
                                                  debutantPrice;

            handleChange({ name: question || 'form.gestion_pack', value: choice });
            handleChange({ name: 'shoppingCart.accounting',        value: selectedPrice });
            dataLayerPush({ event: 'add_to_cart', price: selectedPrice });
            navigate('/gestion/merchant-recap');
        }
    }

    const priceDisplay = (price) => (
        <>
            {price}
            <span className={styles.space}> </span>€
            <span className={styles.space_ht}> </span>
            <span className={styles.exhibitor}>/ mois HT</span>
        </>
    );

    return (
        <div className={`self-step ${styles['self-step']} ${styles['main-21']}`}>
            <div className={`global ${styles.global}`}>
                <div className="questions">
                    Choisissez la formule qui correspond le mieux à <span style={{ color: 'var(--deep-pink)' }}>{companyName}</span> :
                </div>

                {/* Cards — même structure et CSS que form/legal-pack */}
                <div className={styles.offer}>

                    {/* Premium & Réussite */}
                    <div className={styles['offer-main']} style={{ zIndex: 2 }} question='form.gestion_pack'>
                        <div className={styles['offer-box']} onClick={handleSubmit} choice='Premium & Réussite'>
                            <div className={`${styles.reinsurance} ${styles.important}`}>Choisie par 8 personnes sur 10</div>
                            <div className={styles.title}>Premium & Réussite</div>
                            <div className={styles.price}>{priceDisplay(premiumPrice)}</div>
                            <ul>
                                <li>Bilan, liasse fiscale et déclaration de TVA</li>
                                <li>Télétransmission aux impôts</li>
                                <li>Comptable dédié spécialisé dans votre secteur d'activité</li>
                                <li>Disponible par appel, visioconférence et mail 5j/7</li>
                                <li>Conseils illimités et optimisations fiscales</li>
                                <li>Logiciel comptable + tableaux de bord en temps réel</li>
                                <li>Logiciel de facturation illimité</li>
                                <li>Connexion avec plus de 500 API bancaires</li>
                                <li>Catégorisation automatisée des transactions</li>
                                <li>Certification des comptes par l'Expert-Comptable</li>
                                <li>Assistance en cas de contrôle fiscal</li>
                            </ul>
                        </div>
                        <div className="cta" onClick={handleSubmit} choice='Premium & Réussite'>Choisir le pack premium</div>
                    </div>

                    {/* Standard */}
                    <div className={styles['offer-main']} style={{ zIndex: 1 }} question='form.gestion_pack'>
                        <div className={styles['offer-box']} onClick={handleSubmit} choice='Standard'>
                            <div className={styles.title}>Standard</div>
                            <div className={styles.price}>{priceDisplay(standardPrice)}</div>
                            <ul>
                                <li>Bilan, liasse fiscale et déclaration de TVA</li>
                                <li>Télétransmission aux impôts</li>
                                <li>Comptable dédié spécialisé dans votre secteur d'activité</li>
                                <li>Disponible par appel, visioconférence et mail 5j/7</li>
                                <li>Logiciel comptable + tableaux de bord en temps réel</li>
                                <li>Logiciel de facturation illimité</li>
                                <li>Catégorisation automatisée des transactions</li>
                                <li>Certification des comptes par l'Expert-Comptable</li>
                                <li className={styles.not}>Conseils illimités et optimisations fiscales</li>
                                <li className={styles.not}>Connexion avec plus de 500 API bancaires</li>
                                <li className={styles.not}>Assistance en cas de contrôle fiscal</li>
                            </ul>
                        </div>
                        <div className={`cta ${styles.cta}`} onClick={handleSubmit} choice='Standard'>Choisir le pack standard</div>
                    </div>

                    {/* Débutant & Seul */}
                    <div className={styles['offer-main']} style={{ zIndex: 0 }} question='form.gestion_pack'>
                        <div className={styles['offer-box']} onClick={handleSubmit} choice='Débutant & Seul'>
                            <div className={styles.title}>Débutant & Seul</div>
                            <div className={styles.price}>{priceDisplay(debutantPrice)}</div>
                            <ul>
                                <li>Bilan, liasse fiscale et déclaration de TVA</li>
                                <li>Télétransmission aux impôts</li>
                                <li>Comptable dédié avec accompagnement</li>
                                <li>Logiciel comptable + tableaux de bord en temps réel</li>
                                <li className={styles.not}>Disponible par mail uniquement</li>
                                <li className={styles.not}>Conseils illimités et optimisations fiscales</li>
                                <li className={styles.not}>Logiciel de facturation illimité</li>
                                <li className={styles.not}>Connexion avec plus de 500 API bancaires</li>
                                <li className={styles.not}>Catégorisation automatisée des transactions</li>
                                <li className={styles.not}>Assistance en cas de contrôle fiscal</li>
                            </ul>
                        </div>
                        <div className={`cta ${styles.cta}`} onClick={handleSubmit} choice='Débutant & Seul'>Choisir le pack débutant</div>
                    </div>
                </div>

                <div className="actions">
                    <Link to='/gestion/recap'><div className="prev"><div className="arrow"></div>Retour</div></Link>
                    <div className="next" style={{ display: 'none' }}>Continuer</div>
                </div>
            </div>
        </div>
    );
}

export default GestionPacks;
